let SUBSCRIPTION = {};

const $subscriptionIntervalSelector = $(
  'input:hidden[name="subscriptionIntervalId"]'
);
const $subscriptionInterval = $('.js-subscriptionInterval');

SUBSCRIPTION.init = function () {
  onSelectingSubscriptionInterval();
  onSelectingSubscription();
  onToggleSubscriptionAccordion();
  restoreSelectedSubscription();
};

function onSelectingSubscriptionInterval() {
  $subscriptionInterval.change(function () {
    saveSubscriptionInterval();
  });
}

function onSelectingSubscription() {
  $('#activateSubscriptionBtn').on('click', function () {
    enableSubscription();
    window.location.reload();
  });
  $('#deActivateSubscriptionBtn').on('click', function () {
    disableSubscription();
    window.location.reload();
  });
}

function onToggleSubscriptionAccordion() {
  $('#js-showMoreBtn').on('click', function () {
    toggleSubscriptionAccordion(false);
  });
  $('#js-showLessBtn').on('click', function () {
    toggleSubscriptionAccordion(true);
  });
}

function selectSubscriptionInterval(interval) {
  $subscriptionInterval
    .find('option[value="' + interval + '"]')
    .attr('selected', true);
}

function restoreSelectedSubscription() {
  if ($subscriptionIntervalSelector.val()) {
    selectSubscriptionInterval($subscriptionIntervalSelector.val());
    enableSubscription();
  }
}

function enableSubscription() {
  //display subscription stuff
  let subscriptionActivated = saveSubscriptionInterval();
  saveSubscriptionIntervalToSession(subscriptionActivated);
  toggleSubscriptionPlanChoices(subscriptionActivated);
}

function disableSubscription() {
  // disable subscription stuff
  $subscriptionIntervalSelector.val('');
  saveSubscriptionIntervalToSession(null);
  toggleSubscriptionPlanChoices(false);
}

function saveSubscriptionInterval() {
  let interval = $subscriptionInterval.val();
  if (interval) {
    $subscriptionIntervalSelector.val(interval);
    // Change value in modal view
    let val = $(
      '.js-subscriptionInterval option[value=' + interval + ']'
    ).text();
    $('.js-subscriptionModalInterval').text(val);
  }
  return interval;
}

function toggleSubscriptionPlanChoices(activeSubscription = false) {
  if (activeSubscription) {
    $('.active__subscription__section').removeClass('hide');
    $('.inactive__subscription__section').addClass('hide');
    $('.subscription_accordion_handler').addClass('hide');
    $('.subscription__optional__section').removeClass('hide');
    $('.show_less_btn').addClass('hide');
  } else {
    $('.active__subscription__section').addClass('hide');
    $('.inactive__subscription__section').removeClass('hide');
    $('.show_less_btn').removeClass('hide');
  }
}

function toggleSubscriptionAccordion(collapse = false) {
  if (collapse) {
    $('.subscription__optional__section').addClass('hide');
    $('.subscription_accordion_handler').removeClass('hide');
  } else {
    $('.subscription__optional__section').removeClass('hide');
    $('.subscription_accordion_handler').addClass('hide');
  }
}

function saveSubscriptionIntervalToSession(interval) {
  $.ajax({
    type: 'POST',
    url: '/checkout/subscription',
    data: { subscriptionInterval: interval },
  });
}
export default SUBSCRIPTION;
